/**
 * Promo Banner Carousel
 * Shopify OS 2.0 compatible
 */

function initPromoBanner(container) {
  if (!container) return;
  
  const slides = container.querySelector('[data-promo-slides]');
  const prevBtn = container.querySelector('[data-promo-prev]');
  const nextBtn = container.querySelector('[data-promo-next]');

  if (!slides || slides.children.length === 0) return;

  let currentSlide = 0;
  const totalSlides = slides.children.length;
  let autoplayInterval = null;
  const autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;
  const autoplayEnabled = container.dataset.autoplay === 'true';

  function goToSlide(index) {
    if (index < 0) index = totalSlides - 1;
    if (index >= totalSlides) index = 0;
    currentSlide = index;
    slides.style.transform = `translateX(-${currentSlide * 100}%)`;
  }

  function nextSlide() {
    goToSlide(currentSlide + 1);
  }

  function prevSlide() {
    goToSlide(currentSlide - 1);
  }

  function startAutoplay() {
    clearInterval(autoplayInterval);
    if (totalSlides > 1 && autoplayEnabled) {
      autoplayInterval = setInterval(nextSlide, autoplaySpeed);
    }
  }

  function stopAutoplay() {
    clearInterval(autoplayInterval);
    autoplayInterval = null;
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      stopAutoplay();
      prevSlide();
      startAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      stopAutoplay();
      nextSlide();
      startAutoplay();
    });
  }

  // Handle resize to maintain slide position
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      goToSlide(currentSlide);
    }, 100);
  });

  // Start autoplay if enabled
  startAutoplay();

  // Pause on hover (optional UX improvement)
  container.addEventListener('mouseenter', stopAutoplay);
  container.addEventListener('mouseleave', startAutoplay);

  // Store cleanup function for section unload
  container._promoBannerCleanup = () => {
    stopAutoplay();
    clearTimeout(resizeTimeout);
  };
}

function initAllPromoBanners() {
  document.querySelectorAll('[data-promo-banner]').forEach(initPromoBanner);
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllPromoBanners);
} else {
  initAllPromoBanners();
}

// Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  const container = event.target.querySelector('[data-promo-banner]');
  if (container) initPromoBanner(container);
});

document.addEventListener('shopify:section:unload', function(event) {
  const container = event.target.querySelector('[data-promo-banner]');
  if (container && container._promoBannerCleanup) {
    container._promoBannerCleanup();
  }
});
